// import Layout from "../../core/Layout";
import { useState, useEffect, useRef } from "react";

import useDisplayProduct from "./useDisplayProduct";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useOffers from "../offers/useOffers";
import ProductCard from "./utils/ProductCard";
import Bundle from "./Bundle";
import { useAuth } from "../../../utils/AuthContext";
import ManageWishlist from "../../userDashboard/wishlist/ManageWishlist";
import useFetchProduct from "./useFetchProduct";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useCart from "../../userDashboard/cart/useCart";
import useGuestCart from "../../userDashboard/cart/useGuestCart";
import { API } from "../../../config";

const Product = () => {
  const { productId: rproductId } = useParams();
  const [activeImage, setActiveImage] = useState({
    status: "main",
    url: "",
    no: 0,
  });
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isViewed, setIsViewed] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [rproductId]);
  const {
    buyNow,
    // imageZoom,
    addToCartQuantity,
    setAddToCartQuantity,
    product,
    // zoomWrapperRef,
    // zoomImgRef,
  } = useDisplayProduct();

  const {
    addItemToCartFn,
    isAddingItem,
    isGettingCart,
    cartItems,
    removeItemFromCartFn,
    isRemovingItem,
  } = useCart();

  const { addToCart, removeFromCart, isInCart } = useGuestCart();

  const { isLoggedIn } = useAuth();
  const { getRelatedProductsFn, isGettingRelated, errorGettingRelated } =
    useFetchProduct();

  const { activeOffers, isGettingActiveOffers } = useOffers();
  const isInOffer = activeOffers?.filter(
    (offer) => offer?.product?._id === rproductId
  );

  // Function to mark product as viewed
  const markProductAsViewed = () => {
    // Get current viewed products from localStorage
    const viewedProducts = JSON.parse(
      localStorage.getItem("viewedProducts") || "[]"
    );

    // Remove if already exists (to avoid duplicates)
    const filteredProducts = viewedProducts.filter((id) => id !== rproductId);

    // Add to beginning of array
    const updatedProducts = [rproductId, ...filteredProducts];

    // Keep only last 10 viewed products
    const trimmedProducts = updatedProducts.slice(0, 10);

    // Update localStorage
    localStorage.setItem("viewedProducts", JSON.stringify(trimmedProducts));

    // Mark as viewed in state
    setIsViewed(true);
  };

  useEffect(() => {
    if (product?._id && !isViewed) {
      markProductAsViewed(product._id);
    }
  }, [product?._id, isViewed]);

  useEffect(() => {
    setActiveImage((prev) => ({
      ...prev,
      url: `${API}/products/photo/${product?._id}`,
    }));
  }, [product]);

  useEffect(async () => {
    const data = await getRelatedProductsFn(rproductId);
    setRelatedProducts(data);
  }, [rproductId]);

  const handleCartAction = () => {
    if (isLoggedIn) {
      if (cartItems?.items?.some((item) => item?.productId === product?._id)) {
        removeItemFromCartFn(product?._id);
      } else {
        addItemToCartFn({
          productId: product?._id,
          quantity: addToCartQuantity,
        });
      }
    } else {
      if (isInCart(product?._id)) {
        removeFromCart(product?._id);
      } else {
        addToCart({ productId: product?._id, quantity: addToCartQuantity });
      }
    }
  };

  return (
    <div className="container py-8">
      <div className="">
        <div className="productItem">
          <div className="productItemImages">
            <div
              className="
              zoom-wrapper
               border-2"
              // ref={zoomWrapperRef}
              // onMouseMove={imageZoom}
            >
              <img
                // ref={zoomImgRef}
                src={activeImage?.url}
                alt={product?.name}
                className="zoom-img"
                loading="lazy"
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap",
              }}
            >
              {/* {console.log("product: ", product)} */}
              <img
                loading="lazy"
                src={`${
                  API +
                  "/uploads/products/" +
                  product?.photo?.substring(
                    product?.photo?.lastIndexOf("/") + 1
                  )
                }`}
                onClick={() => {
                  setActiveImage((prev) => ({
                    ...prev,
                    url: `${API}/products/photo/${product?._id}`,
                    status: "main",
                    // no: 2,
                  }));
                }}
                alt="itemImage-2"
                style={{
                  width: "100px",
                  objectFit: "contain",
                  marginTop: "1rem",
                  cursor: "pointer",
                  borderRadius: "6px",
                }}
                className={`border  flex flex-wrap ${
                  activeImage.status === "main"
                    ? "border-3 border-gray-800"
                    : "border border-black"
                }`}
              />
              {product?.photos?.map((photo, i) => {
                return (
                  <img
                    loading="lazy"
                    key={i}
                    src={`${
                      API +
                      "/uploads/products/" +
                      photo?.substring(photo?.lastIndexOf("/") + 1)
                    }`}
                    onClick={() => {
                      setActiveImage((prev) => ({
                        ...prev,
                        url: `${
                          API +
                          "/uploads/products/" +
                          photo.substring(photo.lastIndexOf("/") + 1)
                        }`,
                        status: "additional",
                        no: i,
                      }));
                    }}
                    alt="itemImage-2"
                    style={{
                      width: "100px",
                      objectFit: "contain",
                      marginTop: "1rem",
                      cursor: "pointer",
                      borderRadius: "6px",
                    }}
                    className={`border  flex flex-wrap ${
                      activeImage.no === i && activeImage.status !== "main"
                        ? "border-3 border-gray-800"
                        : "border border-black"
                    }`}
                  />
                );
              })}
            </div>
          </div>
          {/* CONTENT OF PRODUCT */}
          <div className="productItemContent flex flex-col gap-2 w-[95%]">
            <div className="py-2 border-b-2 border-gray-300 w-full flex items-center justify-between">
              <h2 className="text-2xl font-bold">{product?.name}</h2>
              <ManageWishlist productId={product?._id} />
            </div>
            {/* Price Display */}
            <div className="flex items-center gap-4 py-2">
              {isInOffer?.length > 0 ? (
                <>
                  <del className="text-xl text-gray-500">
                    {Math.floor(product?.price)} EGP
                  </del>
                  <span className="text-2xl font-bold text-[#DA0E1A]">
                    {isInOffer[0]?.discountType === "fixed"
                      ? Math.floor(product?.price - isInOffer[0].discountValue)
                      : Math.floor(
                          product?.price *
                            (1 - isInOffer[0]?.discountValue / 100)
                        )}
                    EGP
                  </span>
                </>
              ) : (
                <span className="text-2xl font-bold text-[#DA0E1A]">
                  {Math.floor(product?.price)} EGP
                </span>
              )}
            </div>

            {/* Active Offer Display */}
            {isInOffer?.length > 0 && (
              <div className="bg-red-50 p-4 rounded-lg mb-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-[#DA0E1A]">
                      Active Offer!
                    </h3>
                    <p className="text-gray-700">
                      {isInOffer[0]?.description ||
                        `Get ${isInOffer[0]?.discountValue}% off on this product`}
                    </p>
                    {isInOffer[0]?.endDate && (
                      <p className="text-sm text-gray-600 mt-1">
                        Offer ends:{" "}
                        {new Date(isInOffer[0].endDate).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                  <div className="bg-[#DA0E1A] text-white px-4 py-2 rounded-full text-xl font-bold">
                    {isInOffer.length > 0 &&
                    isInOffer[0]?.discountType === "fixed"
                      ? " - " + isInOffer[0]?.discountValue + " EGP OFF"
                      : " - " + isInOffer[0]?.discountValue + "% OFF"}
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-4">
                  <p className="text-green-600 font-semibold">
                    Save{" "}
                    {isInOffer.length > 0 &&
                    isInOffer[0]?.discountType === "fixed"
                      ? isInOffer[0]?.discountValue + " EGP "
                      : Math.floor(
                          product?.price * isInOffer[0]?.discountValue
                        ) / 100}
                    EGP
                  </p>
                </div>
              </div>
            )}

            <p className="mx-auto w-full flex items-center mb-6 text-red-500">
              {product?.category?.name}
            </p>

            <p className="text-xl">{product?.description}</p>
            <p
              className="text-2xl"
              style={{
                fontWeight: "500",
                color:
                  product?.Quentity || product?.quantity === 0
                    ? "#ff0000" // Red for "Out of Stock"
                    : product?.Quentity < 5
                    ? "#f59e0b" // Orange for "Only a few left!"
                    : "#22c55e", // Green for "In Stock"
              }}
            >
              {+product?.Quentity === 0 ||
              +product?.quantity === 0 ||
              (+product?.Quentity || +product?.quantity) < 0
                ? "Coming soon"
                : (+product?.Quentity || +product?.quantity) < 5 &&
                  (+product?.Quentity || +product.quantity) > 0
                ? `Only ${product?.Quentity || product?.quantity} left!`
                : "In Stock"}
            </p>

            {(+product?.Quentity || +product?.quantity) > 0 && (
              <div
                className="ctaCartContainer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3rem",
                  marginTop: "0.75rem",
                }}
              >
                {isLoggedIn ? (
                  cartItems?.items?.some(
                    (item) => item?.productId === product?._id
                  ) ? (
                    ""
                  ) : (
                    <div
                      className="addToCardButtons"
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <button
                        onClick={() => {
                          return setAddToCartQuantity((prev) =>
                            prev < 2 ? 1 : prev - 1
                          );
                        }}
                        style={{
                          padding: "0.25rem 0.75rem",
                          cursor: "pointer",
                          fontSize: "1.75rem",
                          backgroundColor: "transparent",
                          cursor:
                            +addToCartQuantity === 1
                              ? "not-allowed"
                              : "pointer",
                        }}
                        className="border-2 border-gray-500"
                        disabled={+addToCartQuantity === 1}
                      >
                        -
                      </button>
                      <label
                        style={{
                          fontSize: "1.5rem",
                        }}
                      >
                        {addToCartQuantity}
                      </label>

                      <button
                        onClick={() =>
                          setAddToCartQuantity((prev) => {
                            return prev >
                              (+product?.quantity || +product?.Quentity) - 1
                              ? +product?.quantity || +product?.Quentity
                              : prev + 1;
                          })
                        }
                        style={{
                          padding: "0.25rem 0.75rem",
                          cursor: "pointer",
                          fontSize: "1.75rem",
                          backgroundColor: "transparent",
                        }}
                        className="border-2 border-gray-500"
                      >
                        +
                      </button>
                    </div>
                  )
                ) : (
                  <div
                    className="addToCardButtons"
                    style={{
                      display: "flex",
                      gap: "1rem",
                      alignItems: "center",
                    }}
                  >
                    <button
                      onClick={() => {
                        return setAddToCartQuantity((prev) =>
                          prev < 2 ? 1 : prev - 1
                        );
                      }}
                      style={{
                        padding: "0.25rem 0.75rem",
                        cursor: "pointer",
                        fontSize: "1.75rem",
                        backgroundColor: "transparent",
                        cursor:
                          +addToCartQuantity === 1 ? "not-allowed" : "pointer",
                      }}
                      disabled={+addToCartQuantity === 1}
                    >
                      -
                    </button>
                    <label
                      style={{
                        fontSize: "1.5rem",
                      }}
                    >
                      {addToCartQuantity}
                    </label>

                    <button
                      onClick={() =>
                        setAddToCartQuantity((prev) => {
                          return prev >
                            (+product?.quantity || +product?.Quentity) - 1
                            ? +product?.quantity || +product?.Quentity
                            : prev + 1;
                        })
                      }
                      style={{
                        padding: "0.25rem 0.75rem",
                        cursor: "pointer",
                        fontSize: "1.75rem",
                        backgroundColor: "transparent",
                      }}
                    >
                      +
                    </button>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <button
                    onClick={handleCartAction}
                    className={`bg-[#DA0E1A] rounded-xl text-white py-1 px-3 md:py-4 md:px-4 border-none outline-none text-sm md:text-xl cursor-pointer`}
                    disabled={isAddingItem || isRemovingItem}
                  >
                    {isLoggedIn ? (
                      cartItems?.items?.some(
                        (item) => item.productId === product?._id
                      ) ? (
                        isRemovingItem ? (
                          <CustomLoading size="1.25rem" />
                        ) : (
                          "Remove From Cart"
                        )
                      ) : isAddingItem ? (
                        <CustomLoading size="1.25rem" />
                      ) : (
                        "Add To Cart"
                      )
                    ) : isInCart(product?._id) ? (
                      "Remove From Cart"
                    ) : (
                      "Add To Cart"
                    )}
                  </button>
                  <button
                    onClick={buyNow}
                    className="bg-[#DA0E1A] rounded-xl text-white py-1 px-3 md:px-4 border-none outline-none text-sm md:text-xl cursor-pointer"
                  >
                    Buy now
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-12">
        <Bundle />
      </div>

      {/* RELATED PRODUCTS */}
      <div className="related-products mt-12">
        <h2 className="text-2xl font-bold mb-4">Related Products</h2>

        {isGettingRelated ? (
          <div className="flex justify-center items-center min-h-[200px]">
            <CustomLoading size="2rem" />
          </div>
        ) : errorGettingRelated ? (
          <div className="text-center p-4 bg-red-50 text-red-600 rounded-lg">
            <p>Failed to load related products. Please try again later.</p>
          </div>
        ) : relatedProducts?.length === 0 ? (
          <div className="text-center p-4 bg-gray-50 text-gray-600 rounded-lg">
            <p>No related products found.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {relatedProducts?.map((relatedProduct) => (
              <div key={relatedProduct._id}>
                <ProductCard product={relatedProduct} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default Product;
